export default {
  REGISTRATION: "Hand",
  EXTRA_CARD: "Extra Card",
  EXTRA_CARD_TYPE: "extraCard",
  FEE_TYPE: "fee",
  CUSTOM_TYPE: "custom",
  DONATION_TYPE: "donation",
  SERVICE_FEE: "Stripe Processing Fee",
  WAIVOR_CUSTOM_TYPE: "custom",
  WAIVOR_DEFAULT_TYPE: "default",
  PAST: "Past",
  CURRENT: "Current",
  FUTURE: "Future",
  CARD_RELEASE_TYPE_MANUAL: "manual",
  CARD_RELEASE_TYPE_SCHEDULE: "schedule",
  CARD_RELEASE_TYPE_GEO: "geo",
  CARD_RELEASE_STYLE_STRICT: "strict",
  CARD_RELEASE_STYLE_RELAXED: "relaxed",
  CARD_RELEASE_STYLE_STANDARD: "standard",
  CARD_RELEASE_STYLE_SCAVENGER: "scavenger",
  CARD_RELEASE_STYLE_STRICT_TEXT: "Ordered Stops with No Skipping",
  CARD_RELEASE_STYLE_RELAXED_TEXT: "Ordered Stops with Catchup Cards",
  CARD_RELEASE_STYLE_STANDARD_TEXT: "Ordered Stops",
  CARD_RELEASE_STYLE_SCAVENGER_TEXT: "Pick your own Route",
  CARD_RELEASE_STYLE_STRICT_DESC: "All stops must be visited in order. Skipped stops mean lost cards.",
  CARD_RELEASE_STYLE_RELAXED_DESC: "Skipped stops' cards are given at the next stop.",
  CARD_RELEASE_STYLE_STANDARD_DESC: "Stops must be visited in order. Missed stops aren't caught up but can be revisited.",
  CARD_RELEASE_STYLE_SCAVENGER_DESC: "Visit stops in any order.",

  CARD_RELEASE_TYPE_MANUAL_TEXT: "QR Code Scan",
  CARD_RELEASE_TYPE_SCHEDULE_TEXT: "Time Released",
  CARD_RELEASE_TYPE_GEO_TEXT: "GPS Release",

  CARD_RELEASE_TYPE_MANUAL_DESC: "Participants scan a QR code at each stop to receive their card.",
  CARD_RELEASE_TYPE_SCHEDULE_DESC: "Cards are automatically dealt at the scheduled start time of each stop.",
  CARD_RELEASE_TYPE_GEO_DESC: "Cards are dealt when participants arrive at the stop using device GPS.",
};
